<!--A place holder page used while we are still under construction-->

<template>
  <main class="pad">
    <div v-if="!loading">

      <!--Smaller version of page header only used for calendar-->

      <mdb-jumbotron class="white-text mb-0 text-center primary-color"> 
        <h2 class="h1-responsive font-weight-bold mt-5">Coming Soon!</h2>
        <hr />
        <p v-if="page.page_url">Our website is still under construction. Until it is finished, please follow this link to access our old website:</p>
	<p v-else>Our website is still under construction. Check back soon to see this page once it is complete!</p>
        <a v-if="page.page_url" :href="page.page_url" target="_blank"><mdb-btn color="secondary">Access our old website</mdb-btn></a>
      </mdb-jumbotron>
    </div>
  </main>
</template>

<script>
import axios from "axios";
import api from "@/api"
import {
  mdbJumbotron,
  mdbBtn
} from "mdbvue"
export default {
  name: "ComingSoon",
  components: {
    mdbJumbotron,
    mdbBtn
  },
  props: {
    slug: String
  },
  data() {
    return {
      page: String,
      loading: true
    };
  },
  mounted() {
    this.getData();
  },
    methods: {
    getData: function() {
      axios
        api.get("pages/" + this.slug)
        .then(response => {
          this.page = response.data;
        })
        .catch(e => {
          this.errors.push(e);
        })
        .finally(() => (this.loading = false));
    }
  },
  watch: {
    slug: function() {
      // watch it
      this.getData();
    }
  }
}
</script>
